"use client";
import { LoadingState } from "@repo/ui";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";

const PUBLIC_PATHS = [
  "/login",
  "/login/forgot-password",
  "/login/create-password",
  "/add-guest",
];

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && pathname && !PUBLIC_PATHS.includes(pathname)) {
      router.push("/login");
    }
  }, [isAuthenticated, isLoading, pathname, router]);

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <LoadingState variant="page" size="lg" />
      </div>
    );
  }

  if (!isAuthenticated && pathname && !PUBLIC_PATHS.includes(pathname)) {
    return (
      <div className="min-h-screen">
        <LoadingState variant="page" size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}
